import React from "react";
import { IconButton } from "@src/components/atoms/buttons/icon-button/icon-button";
import { SubTitle } from "@src/components/atoms/sub-title/sub-title";
import warningExclamationIcon from "@src/assets/svg/warning-exclamation.svg";
import styles from "./warning-glassy-modal-header.module.scss";

interface WarningGlassyModalHeaderProps {
  title: string;
  warningText: string;
  leftIcon?: string;
  leftIconFunction?: () => void;
  rightIcon?: string;
  rightIconFunction?: () => void;
}

const cssClassName = "warning-glassy-modal-header";

export const WarningGlassyModalHeader = ({
  title,
  warningText,
  leftIcon,
  leftIconFunction,
  rightIcon,
  rightIconFunction,
}: WarningGlassyModalHeaderProps) => {
  const renderIconOrFragment = (icon, callback) => {
    if (icon) {
      return <IconButton fun={callback} icon={icon} />;
    }
    return <div className={styles[`${cssClassName}__placeholder`]}></div>;
  };

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__warning-bar`]}>
        <img
          src={warningExclamationIcon}
          alt="Warning"
          className={styles[`${cssClassName}__warning-icon`]}
        />
        {warningText}
        {rightIcon && (
          <div className={styles[`${cssClassName}__close-btn`]}>
            <IconButton fun={rightIconFunction} icon={rightIcon} />
          </div>
        )}
      </div>
      <div className={styles[`${cssClassName}__header`]}>
        {renderIconOrFragment(leftIcon, leftIconFunction)}
        <SubTitle text={title} />
        <div className={styles[`${cssClassName}__placeholder`]}></div>
      </div>
    </div>
  );
};
